const isEscapeKey = function (e) {
    return e.key === 'Escape';
};
export default isEscapeKey;
